// import OriginTracing from "@atlassiansox/origin-tracing";
import { resolveAnalyticsWebClientPromise } from "@atlassian/wac-analytics-web-client-async";
import type { AnalyticsWebClient } from "@atlassian/wac-analytics-web-client-types";

import DefaultAnalyticsWebClient from "./utils/default-analytics-web-client";

// CHANGED
export const initAnalyticsWebClient = () => {
    let internalClientInitialised: boolean | undefined;
    if (!window.analyticsWebClient) {
        window.analyticsWebClient = new DefaultAnalyticsWebClient();
        internalClientInitialised = window.analyticsWebClient?.init();
    } else {
        internalClientInitialised = !!window.analyticsWebClient.getInstance();
    }
    resolveAnalyticsWebClientPromise(window.analyticsWebClient ?? undefined);

    return internalClientInitialised;
};

export const getAnalyticsWebClient = (): AnalyticsWebClient | undefined =>
    window.analyticsWebClient;
